export default class ToastEventKeys {
    static editToast = "showEditSuccessToast";
    static addToast = "showAddSuccessToast";
    static deleteToast = "showDeleteSuccessToast";
}